module.exports = __webpack_public_path__ + "static/media/WANA.6355ec47.png";